import type { Organization } from './organization';

export enum IntegrationProviders {
  FLINKS = 'FLINKS',
  PLAID = 'PLAID',
  PERSONA = 'PERSONA',
  GOOGLE = 'GOOGLE',
  CANADA_POST = 'CANADA_POST',
  IEX_CLOUD = 'IEX_CLOUD',
  MIXPANEL = 'MIXPANEL',
  LSEG = 'LSEG',
  FIREBASE = 'FIREBASE',
  QUOTE_MEDIA = 'QUOTE_MEDIA',
  ENVESTNET = 'ENVESTNET',
  ATB = 'ATB',
  ONESPAN = 'ONESPAN',
  DOCUSIGN = 'DOCUSIGN',
  ZENDESK = 'ZENDESK',
  SIMILITY = 'SIMILITY',
  SCHWAB = 'SCHWAB',
  NBIN = 'NBIN',
}

export enum IntegrationTypes {
  BANKING = 'BANKING',
  ID_VERIFICATION = 'ID_VERIFICATION',
  ADDRESS = 'ADDRESS',
  MARKET_DATA = 'MARKET_DATA',
  ANALYTICS = 'ANALYTICS',
  FINANCIAL_DATA_WIDGETS = 'FINANCIAL_DATA_WIDGETS',
  DATA_INGESTION = 'DATA_INGESTION',
  PASSTHROUGH_API = 'PASSTHROUGH_API',
  STATISTICS = 'STATISTICS',
  ACCOUNT_DETAILS = 'ACCOUNT_DETAILS',
  FORM = 'FORM',
  CHAT_AGENT = 'CHAT_AGENT',
  FRAUD_DETECTION = 'FRAUD_DETECTION',
  ACCOUNT_OPENING = 'ACCOUNT_OPENING',
}

export type CurrentIntegrationType = {
  configuration: any;
  provider?: IntegrationProviders;
  type: IntegrationTypes;
  state: IntegrationState;
  scope?: string[];
  id: string;
  passthroughApiUrl?: string;
  passthroughApiPrivateSecretName?: string;
};

export type NewIntegrationType = {
  configuration: any;
  provider?: IntegrationProviders | string;
  type: IntegrationTypes | string;
  organizationId: string;
  scope?: string[];
  passthroughApiUrl?: string;
  passthroughApiPrivateSecretName?: string;
};

export type Integration = {
  id?: string;
  configuration: any;
  provider?: IntegrationProviders;
  type: IntegrationTypes;
  organization: Organization;
  state: IntegrationState;
  scope?: string[];
  passthroughApiUrl?: string;
  passthroughApiPrivateSecretName?: string;
};

export const INTEGRATION_TYPES_WITH_NO_PROVIDER = [
  IntegrationTypes.PASSTHROUGH_API,
];

export enum IntegrationState {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE,',
}

export enum IntegrationTransitionState {
  ACTIVATE = 'activate',
  ARCHIVE = 'archive',
  DEACTIVATE = 'deactivate',
}

export enum PassthroughApiTypes {
  TRANSACTION = 'TRANSACTION',
  CASH_AND_HOLDINGS = 'CASH_AND_HOLDINGS',
  STATS_HISTORY = 'STATS_HISTORY',
  PERFORMANCE = 'PERFORMANCE',
  PROJECTED_INCOME = 'PROJECTED_INCOME',
  LIVE_PRICING = 'LIVE_PRICING',
  HOUSEHOLD = 'HOUSEHOLD',
  ENTITY = 'ENTITY',
  ACCOUNT = 'ACCOUNT',
  PRODUCT_SHELF = 'PRODUCT_SHELF',
  BANK_ACCOUNT = 'BANK_ACCOUNT',
  STATEMENT = 'STATEMENT',
}

export enum LinkTokenConfig {
  BASELINE = 'baseline',
  NET_WORTH = 'net_worth',
}
